import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Api } from "../../lib/api";
import { ProfileStore } from "../../lib/cache";
import { useAuth } from "../../context/AuthContext";
import { Button, Card, TextField } from "../../components/ui";

export default function Profile() {
  const cached = ProfileStore.get();
  const [name, setName] = useState(cached?.name ?? "");
  const [email, setEmail] = useState(cached?.email ?? "");
  const [phone, setPhone] = useState(cached?.phone ?? "");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const user = await Api.getProfile();
        if (user) {
          setName(user.name);
          setEmail(user.email);
          setPhone(user.phone);
          ProfileStore.save(user);
        }
      } catch {
        // keep cached values if the fetch fails
      }
    })();
  }, []);

  async function save() {
    setSaving(true);
    setSaved(false);
    try {
      await Api.updateProfile(name, phone);
      setSaved(true);
    } finally {
      setSaving(false);
    }
  }

  async function handleLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  async function deleteAccount() {
    await Api.deleteAccount();
    await logout();
    navigate("/login", { replace: true });
  }

  return (
    <div style={{ maxWidth: 480, display: "flex", flexDirection: "column", gap: 16 }}>
      <h1 style={{ fontSize: 24 }}>Profile</h1>

      <Card>
        <h3 style={{ fontSize: 14 }}>Account</h3>
        <div style={{ height: 12 }} />
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <TextField
            label="Name"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setSaved(false);
            }}
          />
          <TextField label="Email" value={email} readOnly />
          <TextField
            label="Phone (for SMS alerts)"
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
              setSaved(false);
            }}
          />
          <Button fullWidth disabled={saving} onClick={save}>
            {saving ? "Saving…" : saved ? "Saved" : "Save changes"}
          </Button>
        </div>
      </Card>

      <Card>
        <h3 style={{ fontSize: 14 }}>Plan</h3>
        <p style={{ fontSize: 12.5, color: "var(--slate)", margin: "8px 0 12px" }}>
          View or change your current plan.
        </p>
        <Button variant="outlined" fullWidth onClick={() => navigate("/plan")}>
          Manage plan
        </Button>
      </Card>

      <Card>
        <Button variant="outlined" fullWidth onClick={handleLogout}>
          Log out
        </Button>
      </Card>

      <Card>
        <h3 style={{ fontSize: 14, color: "var(--error)" }}>Danger zone</h3>
        <div style={{ height: 10 }} />
        {!confirmDelete ? (
          <Button variant="outlined" tone="error" fullWidth onClick={() => setConfirmDelete(true)}>
            Delete my account
          </Button>
        ) : (
          <>
            <p style={{ fontSize: 12.5, color: "var(--slate)" }}>
              This permanently deletes your account and data. This can&apos;t be undone.
            </p>
            <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
              <Button variant="outlined" fullWidth onClick={() => setConfirmDelete(false)}>
                Cancel
              </Button>
              <Button tone="error" fullWidth onClick={deleteAccount}>
                Confirm delete
              </Button>
            </div>
          </>
        )}
      </Card>
    </div>
  );
}
